export default __webpack_public_path__ + "static/media/start-up.c8a7b589.svg";